<!-- #region HTML -->
<template>
  <div class="app">
    <!-- #region Alert Component -->
    <alert ref="alertComponent" :SystemErrorAlert="isSystemError" :userSaved="userSaved"
      @update:SystemErrorAlert="isSystemError = $event" @update:userSaved="userSaved = $event"></alert>
    <!-- #endregion -->

    <!-- #region Main Container -->
    <div class="main-container form-container">
      <!-- #region Title -->
      <div class="title">
        <label>メールマガジン等の配信設定</label>
      </div>
      <!-- #endregion -->

      <!-- #region Form -->
      <form novalidate class="md-layout" @submit.prevent="validateUser">
        <md-card class="form-container">
          <!-- #region Form Content -->
          <div id="form-is-opt-in-email">
            <!-- #region Information -->
            <div class="main-container no-padding">
              <md-progress-bar v-if="sending" md-mode="indeterminate" />
              <hr>
              <div class="is-opt-in-email-info">
                お届けするEメールには、語学力アップにちょっと役立つメールマガジンや、アルクからのお得なショッピング情報や新商品情報、などが含まれます。
              </div>
            </div>
            <!-- #endregion -->

            <!-- #region Email Opt-in Options -->
            <div class="submit-container">
              <span class="radio-title">アルクからのメールマガジン等の配信を</span>
              <br />
              <md-radio v-model="isOptInEmail" value="true" checked="checked" class="radio-spacing">希望する</md-radio>
              <br />
              <md-radio v-model="isOptInEmail" value="false" class="radio-spacing">希望しない</md-radio>
            </div>
            <!-- #endregion -->
          </div>
          <!-- #endregion -->

          <!-- #region Submit Button -->
          <md-card-actions>
            <md-button type="submit" class="primary-button" :disabled="sending" @click="closeAlert()">変更する</md-button>
          </md-card-actions>
          <!-- #endregion -->
        </md-card>
      </form>
      <!-- #endregion -->
    </div>
    <!-- #endregion -->
  </div>
</template>
<!-- #endregion -->

<!-- #region JavaScript -->
<script>
import { Auth } from 'aws-amplify'
import awsconfig from '@/aws-exports'
import apiUrl from '@/const/api-url.js'
import Alert from '@/layout/Alerts.vue';

export default {
  name: 'ChangeOptIn',
  components: {
    "alert": Alert
  },
  data: () => ({
    isOptInEmail: '',
    userSaved: false,
    sending: false,
    message: '',
    isSystemError: false,
  }),
  async created() {
    this.sending = true
    const API_URL = apiUrl.get_opt_in_api_url(awsconfig.aws_user_pools_id)
    let user = await Auth.currentAuthenticatedUser()
    let resIsOptInEmail = 'false'
    let resIsSystemError = false
    await this.$axios.post(API_URL, { token: user['signInUserSession']['idToken']['jwtToken'] })
      .then(response => {
        if (response.data.body.isOptInEmail) {
          resIsOptInEmail = response.data.body.isOptInEmail === 1 ? 'true' : 'false'
        }
      })
      .catch(() => {
        resIsSystemError = true
      });
    this.isOptInEmail = resIsOptInEmail
    this.isSystemError = resIsSystemError
    this.sending = false
  },
  methods: {
    closeAlert() {
      this.$refs.alertComponent.closeAlert('userSaved');
    },
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName]
      if (field) {
        if (fieldName == 'email') {
          if (field.$anyError) {
            this.isAliasExists = false
          }
        }
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
    clearErrorFlag() {
      this.isSystemError = false
    },
    async saveUser() {
      this.clearErrorFlag()
      this.sending = true
      window.setTimeout(async () => {
        try {
          let user = await Auth.currentAuthenticatedUser()
          const API_URL = apiUrl.change_opt_in_api_url(awsconfig.aws_user_pools_id)
          await this.$axios.post(API_URL,
            {
              token: user['signInUserSession']['idToken']['jwtToken'],
              isOptInEmail: this.isOptInEmail === 'true' ? 1 : 0
            }
          ).then(function (response) {
          }).catch(function (response) {
            this.isSystemError = true
          });
        } catch (error) {
          this.sending = false
          this.isSystemError = true
          return
        }
        this.userSaved = true
        this.sending = false
        setTimeout(() => {
          if (this.$refs.alertComponent != undefined)
            this.$refs.alertComponent.closeAlert('userSaved');
        }, 5000);
      }, 1500)
    },
    async validateUser() {
      this.saveUser()
    },
  },
}
</script>
<!-- #endregion -->

<!-- #region CSS -->
<style lang="scss" scoped>
/* #region Base Styles */
.title {
  margin-bottom: 30px;
}

.is-opt-in-email-info {
  color: var(--text-secondary);
  line-height: var(--line-height-primary);
  text-align: left;
  margin-bottom: 30px;
}

.submit-container {
  padding: 30px 40px;
  box-sizing: border-box;
  text-align: left;
  margin-bottom: 0;
}

.radio-title {
  font-weight: var(--weight-strong);
  font-size: var(--text-size-S) !important;
}

.radio-spacing {
  margin-bottom: 1px;
}

.no-padding {
  padding-top: 0px !important;
}

/* #endregion */

/* #region SP */
@media (max-width: 768px) {
  .is-opt-in-email-info {
    font-size: var(--text-size-S);
  }

  .title {
    font-size: 20px;
    margin-bottom: 24px !important;
  }

  .styled-text {
    font-size: --var(text-size-S);
  }

  .submit-container {
    padding: 24px 16px !important;
    margin:0px 16px;
  }
}

/* #endregion */
</style>
<!-- #endregion -->
